// extracted by mini-css-extract-plugin
export default {"alert":"MyAlert_alert__UbxAa"};